// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-2686a516]{color:#c81919}.schedule--field[data-v-2686a516]{margin-bottom:8px}.schedule--field .left--text[data-v-2686a516]{margin-right:16px}.schedule--field .middle--col[data-v-2686a516]{width:100%}.schedule--field .middle--col .input--field[data-v-2686a516]{width:100%;margin-bottom:8px}.schedule--field .val-error[data-v-2686a516]{margin-left:16px}", ""]);
// Exports
module.exports = exports;
